import { render, staticRenderFns } from "./CrearVODForm.vue?vue&type=template&id=21461a95&scoped=true&"
import script from "./CrearVODForm.vue?vue&type=script&lang=ts&"
export * from "./CrearVODForm.vue?vue&type=script&lang=ts&"
import style0 from "./CrearVODForm.vue?vue&type=style&index=0&id=21461a95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21461a95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('21461a95', component.options)
    } else {
      api.reload('21461a95', component.options)
    }
    module.hot.accept("./CrearVODForm.vue?vue&type=template&id=21461a95&scoped=true&", function () {
      api.rerender('21461a95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/VOD/CrearVODForm.vue"
export default component.exports